var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"d-flex justify-space-between"},[_c('v-flex',{staticClass:"label"}),_c('v-flex',{staticClass:"celling-limits withlabel big van_color11 pa-2 pa-sm-3 pt-sm-0"},[_c('v-divider',{staticClass:"mb-1"}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }